export default __webpack_public_path__ + "static/media/error 404_imagen.76a90f27.png";